import React from "react";
import SettingsTabsComponent from "./settings-tabs.component";

const SettingsTabsContainer = ({tabChanged}:any) => {
  return <SettingsTabsComponent tabChanged={tabChanged} />;
};

export default SettingsTabsContainer;
